import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { Router } from "@angular/router";
import { Subscription } from "rxjs";
import { AppService } from "src/app/core/services/app.service";
import { SurveyService } from "src/app/core/services/survey.service";
import { OOVenueService } from "src/app/core/services/venue-service";
import { SurveyResponse } from "src/app/shared/models/survey.model";

@Component({
	selector: "app-customer-survey-response-list",
	templateUrl: "./customer-survey-response-list.component.html",
	styleUrls: ["../../../commandcenter.scss"],
})
export class CustomerSurveyResponseListComponent implements OnInit {
	@Input() surveyResponsesLoaded: boolean;
	@Output() surveyResponsesLoadedChange = new EventEmitter<boolean>();

	surveyResponseSubscription: Subscription;
	surveyResponseList: SurveyResponse[];

	constructor(public app: AppService, public venueService: OOVenueService, public surveyService: SurveyService, private router: Router) {}

	ngOnInit(): void {
		this.surveyResponseSubscription = this.surveyService.surveyResponseList.subscribe((surveyResponseList) => {
			this.surveyResponseList = [...surveyResponseList];
		});
		this.surveyResponseList = this.surveyService.surveyResponseList.value;
	}

	selectSurvey(rec: SurveyResponse) {
		this.router.navigate([`cc/customers/survey/${rec.surveyKey}/${rec.sk}`]);
	}
}
